export default "__VITE_ASSET__Dw24jo9g__"